import { Checkbox } from '@mui/material';
import { JSX, useState } from 'react';

import { FormLabel } from 'Components/FormField/FormLabel/FormLabel';
import { Text } from 'Components/Text/Text';
import { DueDiligenceSelectableAnswerOption } from 'Models/DueDiligence';

import styles from './DueDiligenceQuestions.module.css';

export interface QuestionMultipleSelectProps {
    answerOptions: DueDiligenceSelectableAnswerOption[];
    formFieldId: string;
    onAnswerChanged: (answerIndices: number[]) => void;

    defaultSelectedIndices?: number[];
    disabled?: boolean;
    questionText?: string;
}

export const QuestionMultipleSelect = (props: QuestionMultipleSelectProps) => {
    const [selectedOptions, setSelectedOptions] = useState<number[]>(props.defaultSelectedIndices ?? []);

    return (
        <>
            {props.questionText && <Text variant="Text2">{props.questionText}</Text>}
            <MultipleChoiceSelectionGroup
                formFieldLabel="Answer"
                disabled={props.disabled}
                formFieldId={props.formFieldId}
                handleChange={(selectedOptions) => {
                    setSelectedOptions(selectedOptions);
                    props.onAnswerChanged(selectedOptions);
                }}
                options={props.answerOptions.map((option, index) => ({
                    isUnacceptable: option.is_unacceptable && selectedOptions.includes(index),
                    text: option.text,
                }))}
                selectedOptions={selectedOptions}
            />
        </>
    );
};

export interface MultipleChoiceOption {
    isUnacceptable?: boolean;
    text: string;
}

export interface MultipleChoiceSelectionGroupProps {
    disabled?: boolean;
    formFieldId: string;
    formFieldLabel?: string;
    handleChange: (answers: number[]) => void;
    options: MultipleChoiceOption[];
    selectedOptions: number[];
    tooltip?: string;
}

export const MultipleChoiceSelectionGroup = ({ disabled = false, ...props }: MultipleChoiceSelectionGroupProps): JSX.Element => {
    const handleCheckItem = (newItem: number) => {
        const selectedList = [...props.selectedOptions];

        if (!props.selectedOptions.includes(newItem)) {
            selectedList.push(newItem);
        } else {
            const index = selectedList.indexOf(newItem);
            selectedList.splice(index, 1);
        }
        props.handleChange(selectedList);
    };

    return (
        <div className={styles.container}>
            {props.formFieldLabel && <FormLabel tooltip={props.tooltip}>{props.formFieldLabel}</FormLabel>}
            <div className={styles.checkboxesContainer}>
                {props.options.map((option, index) => (
                    <div className={styles.checkboxContainer} key={index}>
                        <div>
                            <Checkbox disabled={disabled} name={option.text} checked={props.selectedOptions.includes(index)} onChange={(event: React.FormEvent<HTMLInputElement>) => handleCheckItem(index)} color="default" sx={{ color: 'var(--hps-blue)' }} />
                        </div>
                        <Text noStyles color={option.isUnacceptable ? 'red' : undefined}>
                            {option.text}
                        </Text>
                    </div>
                ))}
            </div>
        </div>
    );
};
